import { render, staticRenderFns } from "./FeedWrapper.vue?vue&type=template&id=21aa75dc&scoped=true&"
import script from "./FeedWrapper.vue?vue&type=script&lang=js&"
export * from "./FeedWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FeedWrapper.vue?vue&type=style&index=0&id=21aa75dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa75dc",
  null
  
)

export default component.exports